<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <ul>
      <p>Todas as suas informações pessoais recolhidas, serão usadas para o ajudar a tornar a sua visita no nosso sistema a mais produtiva e agradável possível.</p>
      <p>A garantia da confidencialidade dos dados pessoais dos utilizadores do nosso site é importante para o Adota Aqui.</p>
      <p>As fotos e informações dos animais registrados podem ser utilizadas para fins de publicidade.</p>
      <p>Os registro de animais antes de serem disponibilizados a todos usuários será avaliado pela equipe do Adota Aqui, mediante diretrizes do sistema, tais como por exemplo: A clareza em visualização do animal na foto, veracidade da foto em relação as informações do registro, se a foto contem apenas 1 (um) animal.</p>
      <p>É proibido realizar publicidade do sistema, sem autorização prévia da equipe Adota Aqui, tal infração poderá resultar na expulsão do utilizador no sistema assim como o acionamento de medidas legais</p>
      <p>É extritamente probido o desrespeito aos outros usuários do sistema, caso seja identicado atitudes ou palavras ofensivas o sistema irá banir o usuário do sistema e tomar medidas legais perante a atitude que inflinge os termos de uso.</p>
      <p>É extritamente proibida a venda de animais dentro do aplicativo Adota Aqui, caso o usuário seja identificado realizando/almejando uma compra ou venda de um animal, sua conta será suspensa imediantamente após a detecção, assim como processos judiciais podem ser acionados ao usuário</p>
      <p>Os dados as atividades dos usuários, tais como usuários em processo de adoção, usuários adotando, número de animais cadastrados pode ser utiizadas a qualquer momento</p>
      <p>As conversas internas no aplicativo podem ser monitoradas a fim de promover ecosistema que respeite os seus usuários e que não inflijam os termos de uso e politicas de privacidade do aplicativo.</p>
      <p>Todas as informações pessoais relativas a membros, assinantes, clientes ou visitantes que usem o adotaaqui serão tratadas em concordância com a Lei da Proteção de Dados Pessoais de 26 de outubro de 1998 (Lei n.º 67/98).</p>
      <p>A informação pessoal recolhida pode incluir o seu nome, e-mail, número de telefone e/ou telemóvel, morada, data de nascimento e/ou outros.</p>
      <p>O uso do Adota Aqui pressupõe a aceitação deste Acordo de privacidade. A equipe do Adota Aqui reserva-se ao direito de alterar este acordo sem aviso prévio. Deste modo, recomendamos que consulte a nossa política de privacidade com regularidade de forma a estar sempre atualizado.</p>
      <h2>Os anúncios</h2>
      <p>Tal como outros aplicativos, coletamos e utilizamos informação contida nos anúncios. A informação contida nos anúncios, inclui o seu endereço IP (Internet Protocol), o seu ISP (Internet Service Provider, como o Sapo, Clix, ou outro), informações sobre o tipo de aparelho smartphone que utiliza, a hora em que acessou o sistema, o tempo da sua visita e os animais observados e as conversas dentro do sistema</p>
      <h2>Os Cookies, Web Beacons e ferramentas de memorização de informações no Sistema</h2>
      <p>Utilizamos cookies e ferramentas de memorização interna do celular para armazenar informação, tais como as suas preferências pessoas quando visita o nosso aplicativo.</p>
      <p>Em adição também utilizamos publicidade de terceiros no nosso sistema para suportar os custos de manutenção. Alguns destes publicitários, poderão utilizar tecnologias como os cookies e/ou web beacons quando publicitam no nosso sistema, o que fará com que esses publicitários (como o Google através do Google AdSense) também recebam a sua informação pessoal, como o endereço IP, o seu ISP, o seu browser, etc. Esta função é geralmente utilizada para geotargeting (mostrar publicidade de Lisboa apenas aos leitores oriundos de Lisboa por ex.) ou apresentar publicidade direcionada a um tipo de utilizador (como mostrar publicidade de restaurante a um utilizador que visita sites de culinária regularmente, por ex.).</p>
      <h2>Ligações a Sites de terceiros</h2>
      <p>O Adota Aqui possui ligações para outros sites, os quais, a nosso ver, podem conter informações e ferramentas úteis para os nossos visitantes. A nossa política de privacidade não é aplicada a sites de terceiros, pelo que, caso visite outro site a partir do nosso deverá ler a politica de privacidade do mesmo.</p>
      <p>Não nos responsabilizamos pela política de privacidade ou conteúdo presente nesses mesmos sites.</p>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      msg: 'Politicas de uso e de Privacidade Aplicativo Adota Aqui',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue